import { atom } from 'recoil';

// Атом для списка формул
export const formulasState = atom({
    key: 'formulasState',
    default: [], // По умолчанию пустой список
});

// Атом для списка терминов (Словарь)
export const termsState = atom({
    key: 'termsState',
    default: [], // По умолчанию пустой список
});

// Атом для состояния загрузки (чтобы крутить спиннер)
export const isLoadingState = atom({
    key: 'isLoadingState',
    default: false,
});



export const authState = atom({
    key: 'authState',
    default: false,
});

export const qrModalState = atom({
    key: 'qrModalState',
    default: false
});